// removed by extract-text-webpack-plugin
module.exports = {"productionTitle":"_1ejTppV-PaaomWL43i0UGh","productionRow":"_25XhR_jUoX-FyIMv0NOIgT","title":"CuLpSuuwJb9PgL-wApnWB","count":"_3aEqCyA1Q0bOeQC_lIq2OY","productionSection":"_1yDcy9_Z_LakO9h5SDjVTh","expandable":"_2jzAynCAmJ8Jse4HnFfqvV","expanded":"_34QEG5NEMev9kedrXMSdkQ","expand":"_1jaIGt9yFjqhwelctZ3wNZ","products":"ZmjnxsDiA_CAtGOTc_-ni","productionExport":"_1jQgGU_aWqnliU1JXEIwBu"};


//////////////////
// WEBPACK FOOTER
// ./app/widgets/ProductionQueue/widget.scss
// module id = 1227
// module chunks = 0